import useGetData from 'hooks/useGetData'
import React, { useMemo } from 'react'
import {
  FormGroup,
  ControlLabel
} from 'react-bootstrap'
import { FormattedMessage } from 'react-intl'
import { KanBoLink } from 'components/Link'
import Loader from 'components/Loader'
import BoardName from 'components/BoardName'
import { Link } from 'react-router-dom'

const DocumentTemplateSourceDetails: React.FC<{
  id: number;
  url: string;
}> = ({
  id,
  url,
}) => {
  
  const args = useMemo(() => ({
    id
  }), [id])
  const {
    data,
  }: {
    data: any
  } = useGetData('DocumentTemplateSourceDetailed', args)

  return data ? (
    <>
      <FormGroup>
        <ControlLabel>
          <FormattedMessage id='DOCUMENTS_SOURCES_TITLE_LIB_URL' />
        </ControlLabel>
        <div>
          <KanBoLink href={url}>{url}</KanBoLink>
        </div>
      </FormGroup>
      <FormGroup>
        <ControlLabel>
          <FormattedMessage
            id='DOCUMENTS_SOURCE_BOARDS_USING'
            values={{ count: data.SelectedInBoardIds.length }}
          />
        </ControlLabel>
        {data.SelectedInBoardIds.map(boardId =>
          <div
            key={boardId}
          >
            <BoardName
              id={boardId}
            >
              {({ name }) => {
                const noAccess = !name && typeof name !== 'undefined'

                return (
                  <Link
                    to={`/board/${boardId}`}
                    target='_blank'
                  >
                    <span
                      className={noAccess ? 'text-danger' : undefined}
                    >
                      {noAccess ? <FormattedMessage id='LINK_KANBO_NO_ACCESS' /> : name}
                    </span>
                  </Link>
                )
              }}
            </BoardName>
          </div>
        )}
      </FormGroup>
    </>
  ) : <Loader center />
}

export default DocumentTemplateSourceDetails
